<template>
	<a-page-header
		style="border: 1px solid rgb(235, 237, 240)"
		title="Accounts"
		sub-title=""
		@back="() => $router.go(-1)"
	>
		<template slot="extra">
			<div class="d-flex">
				<account-export class="mr-2" />
				<account-create class="mr-2" />
				<account-group-manage />
			</div>
		</template>
	</a-page-header>
</template>

<script>
import AccountExport from './Export'
import AccountCreate from './Create'
import AccountGroupManage from './Groups'
export default {
	name: 'AccountTitle',
	components: {
		AccountCreate,
		AccountGroupManage,
		AccountExport,
	},
}
</script>

<style></style>
